<template>
  <Header/>
  <div class="container is-max-desktop my-bookings">
    <h1>Medlemmer</h1>
    <p>Aktive medlemmer, der har været logget ind inden for det seneste år.</p>

    <div v-if="loadError" class="notification is-danger is-light">{{ loadError }}</div>

    <div v-else-if="members.length > 0" class="table-container members-table-wrap">
      <table class="table is-bordered is-striped is-narrow is-hoverable members-table">
        <thead>
          <tr>
            <th
              v-for="col in columns"
              :key="col.key"
              class="is-clickable"
              :aria-sort="sortAria(col.key)"
              @click="sortBy(col.key)"
            >
              {{ col.label }}{{ sortMarker(col.key) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="member in sortedMembers" :key="member.id">
            <td>{{ member.displayName }}</td>
            <td>{{ member.accountName }}</td>
            <td>
              <a v-if="member.phone" :href="phoneTelHref(member.phone)">{{ normalizePhone(member.phone) }}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p v-else-if="loaded">Ingen aktive medlemmer fundet.</p>

    <LoginStatus />
  </div>
  <Footer/>
</template>

<script>
import ax from 'axios'
export const axios = ax

import { defineComponent } from 'vue'
import { useComposition } from '@/compositions/composition'

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import LoginStatus from '@/components/LoginStatus.vue'
import { normalizePhone, phoneTelHref } from '@/phone'

export default defineComponent({
  setup() {
    const { global } = useComposition()
    return { global, normalizePhone, phoneTelHref }
  },
  components: {
    Header,
    Footer,
    LoginStatus,
  },
  data() {
    return {
      members: [],
      loaded: false,
      loadError: '',
      sortKey: 'displayName',
      sortDir: 'asc',
      columns: [
        { key: 'displayName', label: 'Navn' },
        { key: 'accountName', label: 'Husstand' },
        { key: 'phone', label: 'Telefon' },
      ],
    }
  },
  computed: {
    sortedMembers() {
      const key = this.sortKey
      const dir = this.sortDir === 'asc' ? 1 : -1
      return [...this.members].sort((a, b) => {
        const av = String(a[key] || '').toLowerCase()
        const bv = String(b[key] || '').toLowerCase()
        if (av < bv) return -1 * dir
        if (av > bv) return 1 * dir
        return 0
      })
    },
  },
  created() {
    this.loadMembers()
  },
  methods: {
    loadMembers() {
      this.loadError = ''
      axios.get(process.env.VUE_APP_API_ROOT + '/members.php')
        .then((response) => {
          this.members = (response.data && response.data.members) || []
          this.loaded = true
        })
        .catch(() => {
          this.loadError = 'Kunne ikke hente medlemmer. Er du logget ind?'
          this.loaded = true
        })
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
        return
      }
      this.sortKey = key
      this.sortDir = 'asc'
    },
    sortMarker(key) {
      if (this.sortKey !== key) return ''
      return this.sortDir === 'asc' ? ' ↑' : ' ↓'
    },
    sortAria(key) {
      if (this.sortKey !== key) return 'none'
      return this.sortDir === 'asc' ? 'ascending' : 'descending'
    },
  },
})
</script>

<style scoped>
.members-table-wrap {
  overflow-x: auto;
}
.members-table {
  width: auto;
  max-width: 100%;
  font-size: 0.85rem;
}
.members-table th,
.members-table td {
  white-space: nowrap;
}
th.is-clickable {
  cursor: pointer;
  user-select: none;
}
th.is-clickable:hover {
  background-color: #f5f5f5;
}
</style>
